import privacy from "../static/privacypolicy.md";
import change from "../static/changelog.md";

export const PRIVACY = privacy;
export const CHANGE = change;
